const taskstatus = 
	{
        THOUGHT: 0,
        ASAP: 1,
        SCHEDULED: 2,
        DELEGATED: 3,
        SOMEDAY: 4,
        DONECOMPLETE: 5,
        DONENOTCOMPLETE: 6,
    };
export default taskstatus